import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {notification} from 'antd'
import {Mutation} from 'react-apollo'
import moment from 'moment'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import SharingForm from './SharingForm'
import SharingList from './SharingList'
import './index.scss'

const sharingsQuery = gql`
  query SharingsQuery($estateId: ID!) {
    estate(id: $estateId) {
      id
      productsSharings {
        edges {
          node {
            id
            recipientName
            sharingMethod
            recipientEmail
            recipientPhone
            expiresAt
            url
          }
        }
      }
      estateSellers {
        type
        name
        email
        phone
      }
    }
  }
`

const shareProductsMutation = gql`
  mutation ShareProducts($input: ShareProductsInput!) {
    ShareProducts(input: $input) {
      productsSharingsEdge {
        node {
          id
        }
      }
    }
  }
`

const Sharings = ({match}) => {
  return (
    <div className="estate sharings">
      <Heading level={2}>Deling</Heading>
      <Query
        query={sharingsQuery}
        variables={{estateId: match.params.estateId}}
      >
        {({getData, loading, refetch}) => {
          const estateSeller = getData('estate.estateSellers', [])
            .find(s => s.type === 'EstateSeller')

          return (
            <>
              <Mutation
                mutation={shareProductsMutation}
                onCompleted={() => {
                  refetch()
                  notification['success']({
                    message: 'Delingslenke sendt',
                    description: 'Delingslenke er nå sendt til mottaker.',
                  })
                }}
                onError={() => {
                  notification['error']({
                    message: 'Deling feilet',
                    description: 'Kunne ikke opprette delingslenke grunnet en feil. Forsøk på nytt senere.',
                  })
                }}
              >
                {(addSharing, {loading: submitting}) => (
                  <SharingForm
                    isSubmitting={submitting}
                    estateSeller={estateSeller}
                    handleSubmit={(data, form) => {
                      addSharing({variables: {
                        input: {
                          estateId: match.params.estateId,
                          ...data,
                        }
                      }}).then(() => {
                        form.resetFields()
                      })
                    }}
                  />
                )}
              </Mutation>

              <Heading level={2}>Delinger</Heading>
              <SharingList
                loading={loading}
                refetch={refetch}
                sharings={
                  getData('estate.productsSharings.edges', [])
                    .map(({node: sharing}) => ({
                      id: sharing.id,
                      recipientName: sharing.recipientName,
                      recipientEmail: sharing.recipientEmail,
                      recipientPhone: sharing.recipientPhone,
                      expiresAt: moment(sharing.expiresAt).format('DD. MMMM YYYY'),
                      url: sharing.url,
                      key: sharing.id,
                    }))
                }
              />
            </>
          )
        }}
      </Query>
    </div>
  )
}

Sharings.propTypes = {
  match: PropTypes.object.isRequired,
}

export default Sharings
